import { render } from "./clinic-create.vue?vue&type=template&id=0841477a&scoped=true"
import script from "./clinic-create.vue?vue&type=script&lang=js"
export * from "./clinic-create.vue?vue&type=script&lang=js"

import "./clinic-create.vue?vue&type=style&index=0&id=0841477a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0841477a"]])

export default __exports__